import { useTranslation } from 'react-i18next';

interface Props {
  /** Relance les requêtes de chargement, sans rechargement de page. */
  onRetry: () => void;
}

/**
 * DF-0257 — ce que voyait le serveur (ou le convive) quand le réseau calait :
 * rien, indéfiniment. `WaiterShell` / `RestaurantShell` affichaient
 * `NotFoundPage` sur *toute* erreur d'identité, donc un plafond de temps seul
 * aurait transformé « ça charge » en « restaurant introuvable ». Une panne de
 * transport a maintenant son propre écran, avec une sortie.
 */
export default function ConnectionLostNotice({ onRetry }: Props) {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen bg-cream flex items-center justify-center p-8">
      <div className="border-2 border-ink bg-paper p-6 shadow-stamp text-center max-w-sm">
        <h1 className="font-display text-2xl text-ink mb-2">{t('notice.connectionLostTitle')}</h1>
        <p className="font-mono text-ink mb-5">{t('notice.connectionLostBody')}</p>
        <button
          type="button"
          onClick={onRetry}
          className="border-2 border-ink bg-ink text-cream font-display text-lg px-6 py-2 shadow-stamp active:translate-y-px"
        >
          {t('notice.connectionLostRetry')}
        </button>
      </div>
    </main>
  );
}
